module.exports = __webpack_public_path__ + "static/media/YM86_3.1235a3c1.jpg";